import { QueryFactory } from "../../../../Common";
export const QAnnualReport = QueryFactory("AnnualReport");
//# sourceMappingURL=QAnnualReport.js.map